module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/osago-promotion-desktop-fd5f13940fb638b641df4a7562035a3d.png";